module.exports = __webpack_public_path__ + "img/stopwatch_dark.82513c1c.svg";